import React from 'react'

const CurrencyInput = ({
  label,
  value,
  onChange,
  onBlur = () => {},
  normalSize = false,
  className = '',
  style = {},
  ...props
}) => {
  const [isFocused, setIsFocused] = React.useState(false)

  const formatCurrency = value => {
    if (!value) return ''
    const numberValue = parseFloat(value)
    if (isNaN(numberValue)) return ''

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numberValue)
  }

  const handleChange = e => {
    const inputValue = e.target.value
    // Remove everything except digits and decimal point
    const rawValue = inputValue.replace(/[^0-9.]/g, '')

    onChange({
      target: {
        name: e.target.name,
        value: rawValue,
      },
    })
  }

  return (
    <div className='position-relative' style={{ ...style }}>
      {label && (
        <small
          className='position-absolute text-muted'
          style={{
            fontSize: '0.7rem',
            top: '2px',
            left: '8px',
            pointerEvents: 'none',
            zIndex: 1,
          }}
        >
          {label}
        </small>
      )}
      <input
        type='text'
        value={isFocused ? value : formatCurrency(value)}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={e => {
          setIsFocused(false)
          onBlur(e)
        }}
        className={`form-control ${!normalSize ? 'form-control-sm' : ''} ${className}`}
        style={
          !normalSize
            ? {
                paddingTop: label ? '18px' : '4px',
                paddingBottom: '4px',
                ...style,
              }
            : { ...style }
        }
        {...props}
      />
    </div>
  )
}

export default CurrencyInput
